import { css } from 'styled-components';
import { DisclaimerNoteProps } from './models';

export const DisclaimerNote = css<DisclaimerNoteProps>(({ theme }) => {
  return css`
    font-size: 10px;
    color: ${theme.colors.darkGray};
    text-align: left;
  `;
});
